import { styled } from "@mui/material/styles";
import { Link } from "@mui/material";

import ResponsiveImage from "components/ResponsiveImage";

export const Background = styled("div")(({ backgroundImage, backgroundColor }) => ({
  backgroundColor: backgroundColor || "transparent",
  backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
  backgroundRepeat: "repeat-x",
  backgroundSize: "auto 100%",
}));

export const StyledLink = styled(Link)({
  width: "fit-content",
  display: "block",
  margin: "0 auto 40px",
});

export const StyledResponsiveImage = styled(ResponsiveImage)({
  display: "block",
  margin: "0 auto 40px",
  width: "auto",
  maxWidth: "100%",
  maxHeight: 400,
});
